<template>
  <AddEditTemplate
    v-if="formData && !loading"
    :isEditMode="isEditMode"
    addEditType="Instructor"
    :initialData="formData"
    :submitAction="submitForm"
  >
    <template #default="{ formData }">
      <AddEditFormGroup
        label="First Name"
        fieldId="firstName"
        v-model="formData.firstName"
        required
      />
      <AddEditFormGroup
        label="Last Name"
        fieldId="lastName"
        v-model="formData.lastName"
        required
      />
      <AddEditFormGroup
        label="Email"
        fieldId="email"
        v-model="formData.email"
        type="email"
        required
      />
      <AddEditFormGroup
        label="Phone"
        fieldId="phone"
        v-model="formData.phone"
        type="tel"
      />
      <AddEditFormGroup
        label="Source"
        fieldId="sourceId"
        v-model="formData.sourceId"
        component="select"
        :options="sourceOptions"
      />
      <AddEditFormGroup
        label="Shirt Size"
        fieldId="shirtSizeId"
        v-model="formData.shirtSizeId"
        component="select"
        :options="shirtSizeOptions"
      />
      <AddEditFormGroup
        label="Notes"
        fieldId="notes"
        v-model="formData.notes"
        component="textarea"
      />
      <AddEditFormGroup
        label="Initial Sit-Down"
        fieldId="initialSitDown"
        v-model="formData.initialSitDown"
        type="date"
      />
      <AddEditFormGroup
        label="Medical Status"
        fieldId="medicalStatusId"
        v-model="formData.medicalStatusId"
        component="select"
        :options="medicalStatusOptions"
      />
      <AddEditFormGroup
        label="Company Contact"
        fieldId="companyContact"
        v-model="formData.companyContact"
      />
    </template>
  </AddEditTemplate>
</template>

<script>
import PotentialInstructorsAPIService from "src/servicehandlers/PotentialInstructorsAPIService";
import PotentialInformationAPIService from "src/servicehandlers/PotentialInformationAPIService";
import AddEditTemplate from "./AddEditTemplate.vue";
import AddEditFormGroup from "./AddEditFormGroup.vue";
const potentialInstructorsAPIService = new PotentialInstructorsAPIService();
const potentialInformationAPIService = new PotentialInformationAPIService();
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
dayjs.extend(utc);

export default {
  components: { AddEditFormGroup, AddEditTemplate },
  data() {
    return {
      isEditMode: false,
      loading: true,
      formData: {
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        sourceId: "",
        shirtSizeId: "",
        notes: "",
        initialSitDown: "",
        medicalStatusId: "",
        companyContact: "",
        seatCharge: false,
        orientationEmailSent: false,
        onboarded: false,
        applicationEmailSent: false,
      },
      medicalStatusOptions: [],
      shirtSizeOptions: [],
      sourceOptions: [],
    };
  },
  async created() {
    if (this.$route.params.id) {
      this.isEditMode = true;
      await this.getInstructor(this.$route.params.id);
    }
    await Promise.all([
      this.getMedicalStatusOptions(),
      this.getShirtSizeOptions(),
      this.getSourceOptions(),
    ]);

    this.loading = false;
  },
  methods: {
    async getInstructor(id) {
      try {
        const response =
          await potentialInstructorsAPIService.getInstructorById(id);
        this.formData = {
          ...response,
          lastName: response.user.lastName,
          firstName: response.user.firstName,
          email: response.user.email,
          phone: response.user.phone,
          sourceId: response.source?.id,
          shirtSizeId: response.shirtSize?.id,
          initialSitDown: response.initialSitDown
            ? dayjs(response.initialSitDown).utc().format("YYYY-MM-DD")
            : "",
          medicalStatusId: response.medicalStatus?.id,
        };
      } catch (error) {}
    },
    async getMedicalStatusOptions() {
      try {
        this.medicalStatusOptions =
          await potentialInformationAPIService.getMedicalStatusOptions();
      } catch (error) {}
    },
    async getShirtSizeOptions() {
      try {
        this.shirtSizeOptions =
          await potentialInformationAPIService.getShirtSizeOptions();
      } catch (error) {}
    },
    async getSourceOptions() {
      try {
        this.sourceOptions =
          await potentialInformationAPIService.getSourceOptions();
      } catch (error) {}
    },
    async submitForm(formData) {
      try {
        if (this.isEditMode) {
          await potentialInstructorsAPIService.update(
            this.$route.params.id,
            formData,
          );
        } else {
          await potentialInstructorsAPIService.create(formData);
        }
      } catch (error) {}
    },
  },
};
</script>

<style scoped></style>
